import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import EPG from "./EPG";
import "./EPG.css";
import WithAuthorization from "../../../../app/src/Utils/WithAuthorization";

const EPGPage = (props) => {
  const history = useHistory();
  const { scrollRef } = props;

  useEffect(() => {
    scrollRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }, [scrollRef]);

  return (
    <div>
      <EPG />
    </div>
  );
};

export default WithAuthorization(EPGPage);